/* ==========================================================================
 * bb-kern.js - NIET MET DE HAND AANPASSEN
 * --------------------------------------------------------------------------
 * Dit bestand is gemaakt door thema/gedeeld/gereedschap/bouw-kern.mjs uit
 * rekentools/kern.js. Alles hieronder tussen de bakens is die bron, regel voor
 * regel, met alleen het woord "export" weggehaald. Wijzigingen horen in
 * rekentools/kern.js thuis; daarna dit script opnieuw draaien.
 *
 * Waarom: rekentools/kern.js is over duizenden gevallen naast de code van de
 * live WooCommerce-site gelegd, met nul verschillen. Overtikken zou dat bewijs
 * weggooien.
 *
 * Gedeeld door de keuzehulp en de paneelhulp. Beide tools laden dit bestand
 * als gewoon script met defer en lezen daarna window.BBKern.
 * ========================================================================== */
(function (global) {
	'use strict';

	/* ---------- BEGIN rekentools/kern.js ---------- */
	/**
	 * kern.js - de rekenkern van de Birdblocker keuzehulp en paneelhulp,
	 * losgeknipt van WordPress en van het scherm.
	 *
	 * WAT DIT BESTAND IS
	 * Een letterlijke overzetting van het rekenwerk dat nu in bb-keuzehulp.php en
	 * bb-paneelhulp.php in een <script>-blok staat. Er is niets aan de regels
	 * veranderd: dezelfde formules, dezelfde afrondingen, in dezelfde volgorde,
	 * inclusief de foefjes met 0.000001 die voorkomen dat een deling die
	 * rekenkundig precies uitkomt door de onnauwkeurigheid van kommagetallen
	 * een rol te veel oplevert.
	 *
	 * Dat "letterlijk" is niet op mijn woord aan te nemen: test.mjs draait dit
	 * bestand naast de VERBATIM uit de plugins geknipte code in origineel/ en
	 * vergelijkt de uitkomsten over duizenden gevallen. Het pallet-deel wordt
	 * bovendien vergeleken met de PHP-rekenkern van bb-korting.
	 *
	 * WAT DIT BESTAND NIET IS
	 * Er zit geen DOM, geen fetch, geen Liquid en geen WooCommerce in. Het weet
	 * niets van winkelwagens en niets van Shopify. Dat is met opzet: dit is het
	 * enige stuk waar geld aan hangt, en dat moet los na te rekenen zijn zonder
	 * dat je eerst een webshop hoeft op te starten.
	 *
	 * DE GEGEVENS DIE ERIN GAAN (de "G" uit de plugins)
	 *   producten[]  { id, naam, url, sku, diameter, meters, rollen,
	 *                  rollen_per_pallet, centen, vancenten }
	 *   pallet       { "12": 60, "15": 48, "20": 48 }   rollen per pallet
	 *   winkelwagen  { "12": 4 }                        rollen die al in de wagen liggen
	 *   treden       { een: 5, twee: 10 }               kortingspercentages
	 *
	 * centen en vancenten zijn HELE CENTEN inclusief btw. In centen rekenen is
	 * geen detail: het voorkomt dat twee combinaties met exact dezelfde prijs door
	 * een afrondingsrestje toch verschillend uitvallen.
	 */

	/* =========================================================================
	 * 1. OPMAAK VAN GETALLEN
	 * Staat hier omdat de teksten op het scherm ("26,40 m", "EUR 94,97") uit
	 * exact deze functies komen. Wijkt de opmaak af, dan ziet de klant een ander
	 * getal dan de oude site, ook als het rekenwerk klopt.
	 * ====================================================================== */

	/** '€ 94,97' uit 9497 centen. */
	function euroUitCenten(c) {
		return '€ ' + (c / 100).toFixed(2).replace('.', ',');
	}

	/** Nederlands getal; een rond bedrag verliest zijn ",00". */
	function getal(v, decimalen) {
		var n = Number(v);
		if (!isFinite(n)) { n = 0; }
		return n.toFixed(decimalen === undefined ? 2 : decimalen).replace('.', ',').replace(/,00$/, '');
	}

	/** '26,40 m' */
	function meterTekst(v) { return getal(v, 2) + ' m'; }

	/** Het percentage zoals de klant het intypte: 10 blijft 10, 7,5 blijft 7,5. */
	function procentTekst(p) { return getal(p, 2).replace(/,(\d)0$/, ',$1'); }

	/** Een vlak van precies een paneel bestaat echt, dus nooit "1 panelen". */
	function paneelWoord(n) { return n === 1 ? 'paneel' : 'panelen'; }

	/* =========================================================================
	 * 2. DE PRODUCTEN
	 * ====================================================================== */

	/** De diameters die er zijn, oplopend. */
	function diameters(producten) {
		var uit = [];
		producten.forEach(function (p) {
			if (uit.indexOf(p.diameter) < 0) { uit.push(p.diameter); }
		});
		uit.sort(function (a, b) { return a - b; });
		return uit;
	}

	/**
	 * De artikelen van een diameter.
	 *
	 * LET OP: de volgorde van deze lijst is niet vrijblijvend. metersPerRol()
	 * pakt het eerste artikel, en de rekenkern kiest bij twee even dure pakketten
	 * met evenveel rollen het artikel dat het eerst in de lijst staat. De
	 * bronvolgorde is oplopend op diameter en daarbinnen oplopend op lengte
	 * (zo levert bb_kh_producten() hem aan) en die moet zo blijven.
	 */
	function vanDiameter(producten, d) {
		return producten.filter(function (p) { return p.diameter === d; });
	}

	/**
	 * Meters per rol binnen een diameter: 4 m bij Ø12 en Ø15, 2 m bij Ø20.
	 * Wordt afgeleid uit het product zelf (meters gedeeld door rollen), zodat er
	 * geen tweede waarheid in de code staat.
	 */
	function metersPerRol(producten, d) {
		var lijst = vanDiameter(producten, d);
		return lijst.length ? (lijst[0].meters / lijst[0].rollen) : 0;
	}

	/**
	 * De kleinste borstel die een gemeten opening opvult.
	 * Geeft null als de opening groter is dan de dikste maat die we voeren.
	 */
	function passendeDiameter(producten, openingCm) {
		var ds = diameters(producten);
		var passend = null;
		ds.forEach(function (d) { if (passend === null && d >= openingCm) { passend = d; } });
		return passend;
	}

	/* =========================================================================
	 * 3. VAN METERS NAAR ROLLEN
	 * ====================================================================== */

	/**
	 * Hoeveel hele rollen dekken dit aantal meters?
	 *
	 * Naar boven afgerond, want een halve rol bestaat niet. Het aftrekken van
	 * 0.000001 vangt af dat 12 / 4 door de onnauwkeurigheid van kommagetallen als
	 * 3,0000000001 uit de deling komt en dan onterecht 4 rollen zou opleveren.
	 * Minimaal 1 rol, want wie iets nodig heeft, heeft minstens een rol nodig.
	 */
	function rollenNodig(meters, perRol) {
		if (perRol <= 0) { return 0; }
		var n = Math.ceil((meters / perRol) - 0.000001);
		return n < 1 ? 1 : n;
	}

	/* =========================================================================
	 * 4. HET VOORDELIGSTE PAKKET ROLLEN
	 * ------------------------------------------------------------------------
	 * Dit is geen schatting en geen "pak de grootste rol tot het op is". Grote
	 * rollen zijn per meter goedkoper (12 m Ø12 kost 39,99 = 3,33/m, 4 m kost
	 * 14,99 = 3,75/m), maar de grootste rol pakken kan alsnog duurder uitpakken
	 * zodra er een restje overblijft dat je met een grote rol moet afdekken.
	 *
	 * Daarom wordt het uitgerekend met een tabel die van onderaf wordt opgebouwd:
	 *
	 *   dp[k] = de goedkoopste manier om MINSTENS k rollen te krijgen
	 *         = het minimum over alle artikelen van
	 *           (prijs van dat artikel + dp[k - rollen in dat artikel])
	 *
	 * Doordat er "minstens" staat en het aantal resterende rollen op nul wordt
	 * afgekapt, wordt een artikel dat over de rand heen schiet automatisch
	 * meegewogen. Bij een gelijke prijs wint de combinatie met de MINSTE rollen,
	 * want dat is de minste restmeters.
	 * ====================================================================== */

	function goedkoopstePakket(lijst, nodigRollen) {
		if (!lijst.length || nodigRollen < 1) { return null; }

		var dp = new Array(nodigRollen + 1);
		dp[0] = { centen: 0, rollen: 0, keuze: -1 };

		for (var k = 1; k <= nodigRollen; k++) {
			var beste = null;
			for (var i = 0; i < lijst.length; i++) {
				var vorig = dp[Math.max(0, k - lijst[i].rollen)];
				var kandidaat = {
					centen: vorig.centen + lijst[i].centen,
					rollen: vorig.rollen + lijst[i].rollen,
					keuze: i
				};
				if (!beste
					|| kandidaat.centen < beste.centen
					|| (kandidaat.centen === beste.centen && kandidaat.rollen < beste.rollen)) {
					beste = kandidaat;
				}
			}
			dp[k] = beste;
		}
		return samenstelling(dp, lijst, nodigRollen);
	}

	/**
	 * Dezelfde tabel, maar dan met "precies k rollen" in plaats van "minstens k
	 * rollen". Levert het pakket zonder ook maar een halve rol over. Omdat er van
	 * elke maat een losse rol bestaat, lukt dat altijd.
	 *
	 * Alleen de keuzehulp gebruikt dit; de paneelhulp toont deze tweede kaart niet.
	 */
	function preciesPakket(lijst, nodigRollen) {
		if (!lijst.length || nodigRollen < 1) { return null; }
		var dp = new Array(nodigRollen + 1);
		dp[0] = { centen: 0, rollen: 0, keuze: -1 };
		for (var k = 1; k <= nodigRollen; k++) {
			var beste = null;
			for (var i = 0; i < lijst.length; i++) {
				if (lijst[i].rollen > k) { continue; }
				var vorig = dp[k - lijst[i].rollen];
				if (!vorig) { continue; }
				var kandidaat = { centen: vorig.centen + lijst[i].centen, rollen: k, keuze: i };
				if (!beste || kandidaat.centen < beste.centen) { beste = kandidaat; }
			}
			dp[k] = beste;
		}
		return dp[nodigRollen] ? samenstelling(dp, lijst, nodigRollen) : null;
	}

	/** Leest uit de tabel terug welke artikelen er in het pakket zitten. */
	function samenstelling(dp, lijst, nodigRollen) {
		var telling = {};
		var k = nodigRollen;
		var veiligheid = 0;
		while (k > 0 && dp[k] && veiligheid++ < 10000) {
			var i = dp[k].keuze;
			telling[i] = (telling[i] || 0) + 1;
			k = Math.max(0, k - lijst[i].rollen);
		}

		var regels = [];
		var centen = 0, rollen = 0, meters = 0;
		Object.keys(telling).forEach(function (sleutel) {
			var p = lijst[Number(sleutel)];
			var n = telling[sleutel];
			regels.push({ product: p, aantal: n });
			centen += p.centen * n;
			rollen += p.rollen * n;
			meters += p.meters * n;
		});
		// Van groot naar klein leest prettiger: "2x 12 m + 1x 4 m".
		regels.sort(function (a, b) { return b.product.meters - a.product.meters; });

		return { regels: regels, centen: centen, rollen: rollen, meters: meters };
	}

	/** Twee pakketten zijn hetzelfde als ze uit dezelfde artikelen in dezelfde aantallen bestaan. */
	function zelfdePakket(a, b) {
		if (!a || !b || a.regels.length !== b.regels.length) { return false; }
		for (var i = 0; i < a.regels.length; i++) {
			if (a.regels[i].product.id !== b.regels[i].product.id) { return false; }
			if (a.regels[i].aantal !== b.regels[i].aantal) { return false; }
		}
		return true;
	}

	/* =========================================================================
	 * 5. PALLETKORTING
	 * ------------------------------------------------------------------------
	 * Dezelfde regel als in de winkelwagen: we tellen ROLLEN, niet dozen en niet
	 * meters, en we tellen over de HELE bestelling (alle maten samen). Wat de
	 * klant al in zijn winkelwagen heeft liggen telt gewoon mee.
	 * ====================================================================== */

	/** De optelsom van de pallet-delen per diameter. 1,0 = precies een volle pallet. */
	function palletDeel(pallet, rollenPerDiameter) {
		var som = 0;
		Object.keys(rollenPerDiameter).forEach(function (d) {
			var per = pallet[d];
			if (per > 0) { som += rollenPerDiameter[d] / per; }
		});
		return som;
	}

	/**
	 * Het aantal VOLLE pallets. Naar beneden afgerond, maar pas na een kleine
	 * marge: zonder die marge zou 20/60 + 16/48 + 16/48 als 0,99999999 uit de
	 * deling komen en dus als "geen volle pallet" gelden, terwijl het er
	 * rekenkundig precies een is.
	 */
	function vollePallets(deel) {
		return Math.floor(deel + 0.000001);
	}

	/** 1 volle pallet = 5%, 2 of meer = 10%. Boven de 2 loopt het niet verder op. */
	function percentageBij(treden, pallets) {
		if (pallets >= 2) { return treden.twee; }
		if (pallets >= 1) { return treden.een; }
		return 0;
	}

	/** De rollen van het voorstel, opgeteld bij wat er al in de winkelwagen ligt. */
	function rollenMetVoorstel(winkelwagen, diameter, rollen) {
		var uit = {};
		Object.keys(winkelwagen).forEach(function (d) { uit[d] = winkelwagen[d]; });
		uit[diameter] = (uit[diameter] || 0) + rollen;
		return uit;
	}

	/**
	 * Hoeveel rollen van DEZE maat er nog bij moeten voor de eerste kortingstrede.
	 * Wordt alleen gebruikt als er nog geen korting is (dus deel < 1).
	 */
	function rollenTotEersteTrede(deel, rollenPerPallet) {
		var tekort = Math.ceil(((1 - deel) * rollenPerPallet) - 0.000001);
		return tekort < 1 ? 1 : tekort;
	}

	/**
	 * Het kortingsbedrag zoals de KAART het toont: gewoon afgerond op hele centen
	 * over de prijs inclusief btw.
	 *
	 * LET OP: dit is een SCHATTING, en de tekst op het scherm zegt dat er ook bij
	 * ("dat scheelt ongeveer ... De winkelwagen rekent het exacte bedrag uit").
	 * De winkelwagen zelf rekent met de waarde EXCLUSIEF btw en rondt naar BOVEN
	 * af (zie bb-korting: ceil(bedrag * 100 - 0.000001) / 100), zodat de klant
	 * nooit minder dan de beloofde 5 of 10 procent krijgt. Die twee kunnen een
	 * cent uit elkaar liggen. Neem deze functie dus NIET als grondslag voor de
	 * echte korting.
	 */
	function geschatteKortingCenten(pakketCenten, percentage) {
		return Math.round(pakketCenten * percentage / 100);
	}

	/**
	 * De echte kortingsregel van bb-korting, een op een overgezet uit
	 * bb-korting-rekenkern.php. Grondslag in centen (of in euro's; de functie
	 * rekent met wat ze krijgt), naar boven afgerond op hele centen.
	 * Nodig zodra de korting op Shopify zelf herbouwd wordt.
	 */
	function kortingAfrondenOmhoog(bedrag) {
		return Math.ceil((Number(bedrag) * 100) - 0.000001) / 100;
	}

	function kortingBedrag(grondslag, percentage) {
		grondslag = Number(grondslag);
		percentage = Number(percentage);
		if (grondslag <= 0 || percentage <= 0) { return 0; }
		return kortingAfrondenOmhoog(grondslag * percentage / 100);
	}

	/* =========================================================================
	 * 6. KEUZEHULP: VAN INVOER NAAR METERS
	 * ------------------------------------------------------------------------
	 * Twee ingangen. De een heeft zijn dak opgemeten en weet het aantal meters,
	 * de ander weet alleen hoeveel zonnepanelen er liggen.
	 *
	 * De paneelbreedte is GEEN productgegeven maar een aanname die zichtbaar op
	 * het scherm staat en die de klant zelf overschrijft: 1,70 m is de lange
	 * zijde van een gangbaar paneel.
	 * ====================================================================== */

	var KH_PANEEL_BREEDTE = 1.70;
	var KH_MAX_METERS = 2000;

	/** Ingang "ik weet het aantal meters": meters + extra. */
	function keuzehulpMetersUitMeters(meters, extra) {
		if (!(extra > 0)) { extra = 0; }
		return meters + extra;
	}

	/** Ingang "ik weet het aantal panelen": panelen x breedte x zijden, daarna extra erbij. */
	function keuzehulpMetersUitPanelen(panelen, breedte, zijden, extra) {
		if (!(extra > 0)) { extra = 0; }
		return (panelen * breedte * zijden) + extra;
	}

	/* =========================================================================
	 * 7. PANEELHULP: VAN DE TEKENING NAAR METERS
	 * ------------------------------------------------------------------------
	 * Per vlak is L de lange zijde van het paneel en B de korte, allebei in
	 * CENTIMETERS in de invoer. Een vlak is een rij van N panelen naast elkaar:
	 *
	 *   liggend : rijbreedte = N x L   rijhoogte = B
	 *   staand  : rijbreedte = N x B   rijhoogte = L
	 *
	 * En dan, afhankelijk van welke randen dicht moeten:
	 *
	 *   alleen onderzijde : rijbreedte
	 *   onder en boven    : 2 x rijbreedte
	 *   hele omtrek       : 2 x (rijbreedte + rijhoogte)
	 *
	 * DE VOLGORDE IS HIER HET HELE VERHAAL: de vlakken worden opgeteld, daarna
	 * gaat de marge erbij, en PAS DAARNA wordt er naar boven afgerond op hele
	 * rollen. Andersom afronden (eerst per vlak) kost de klant bij vier vlakken
	 * zomaar een rol te veel.
	 * ====================================================================== */

	var PH_LANG_STANDAARD = 170;   // lange zijde in centimeters
	var PH_KORT_STANDAARD = 110;   // korte zijde in centimeters
	var PH_AANTAL_STANDAARD = 10;  // panelen naast elkaar in een vlak
	var PH_MARGE_STANDAARD = 10;   // procent speling
	var PH_MAX_METERS = 2000;
	var PH_MAX_GROEPEN = 8;
	var PH_MAX_PANELEN = 200;

	/**
	 * De lange en de korte zijde in meters. Wie de twee velden per ongeluk omdraait
	 * krijgt toch een kloppende uitkomst: de grootste van de twee is per definitie
	 * de lange zijde.
	 */
	function vlakLang(g) { return Math.max(g.lang, g.kort) / 100; }
	function vlakKort(g) { return Math.min(g.lang, g.kort) / 100; }

	function rijBreedte(g) {
		return g.aantal * (g.ligging === 'staand' ? vlakKort(g) : vlakLang(g));
	}
	function rijHoogte(g) {
		return g.ligging === 'staand' ? vlakLang(g) : vlakKort(g);
	}

	/** De meters vogelwering voor een vlak, puur uit de randkeuze. */
	function vlakMeters(g) {
		var b = rijBreedte(g);
		var h = rijHoogte(g);
		if (g.randen === 'omtrek') { return 2 * (b + h); }
		if (g.randen === 'onderboven') { return 2 * b; }
		return b;
	}

	/** Een vlak zonder maten of zonder panelen telt niet mee. */
	function vlakGeldig(g) {
		return g.lang > 0 && g.kort > 0 && g.aantal >= 1;
	}

	function totaalKaal(vlakken) {
		var som = 0;
		vlakken.forEach(function (g) { if (vlakGeldig(g)) { som += vlakMeters(g); } });
		return som;
	}

	/** De marge komt er in een keer overheen, over het totaal van alle vlakken. */
	function metMarge(kaal, m) {
		if (m.soort === 'meters') { return kaal + Math.max(0, m.meters); }
		return kaal * (1 + Math.max(0, m.procent) / 100);
	}

	/* =========================================================================
	 * 8. DE HELE KETEN IN EEN AANROEP
	 * ------------------------------------------------------------------------
	 * Handig voor de Shopify-section: een invoer erin, een compleet advies eruit.
	 * Deze twee functies bevatten zelf geen rekenregel; ze zetten de stappen
	 * hierboven in de goede volgorde.
	 * ====================================================================== */

	/**
	 * Keuzehulp, van meters naar advies.
	 *
	 * @param {object} G          { producten, pallet, winkelwagen, treden }
	 * @param {number} meters     Het aantal meters uit stap 2 (inclusief extra).
	 * @param {number} diameter   De gekozen diameter in cm.
	 */
	function keuzehulpAdvies(G, meters, diameter) {
		var lijst = vanDiameter(G.producten, diameter);
		if (!lijst.length) { return null; }

		var perRol = metersPerRol(G.producten, diameter);
		var nodig = rollenNodig(meters, perRol);

		var goedkoopst = goedkoopstePakket(lijst, nodig);
		var precies = preciesPakket(lijst, nodig);
		if (!goedkoopst) { return null; }

		// De tweede kaart verschijnt alleen als het goedkoopste pakket ECHT een rol
		// te veel bevat en er een pakket bestaat met minder rollen.
		var toonPrecies = !!(precies && precies.rollen < goedkoopst.rollen && !zelfdePakket(precies, goedkoopst));

		return {
			meters: meters,
			diameter: diameter,
			metersPerRol: perRol,
			nodigRollen: nodig,
			goedkoopst: goedkoopst,
			precies: precies,
			toonPrecies: toonPrecies,
			pallet: palletStand(G, diameter, goedkoopst)
		};
	}

	/**
	 * Paneelhulp, van vlakken naar advies.
	 *
	 * @param {object} G        { producten, pallet, winkelwagen, treden }
	 * @param {array}  vlakken  [{ lang, kort, aantal, ligging, randen }]
	 * @param {object} marge    { soort: 'procent'|'meters', procent, meters }
	 * @param {number} diameter De gekozen diameter in cm.
	 */
	function paneelhulpAdvies(G, vlakken, marge, diameter) {
		var lijst = vanDiameter(G.producten, diameter);
		if (!lijst.length) { return null; }

		var kaal = totaalKaal(vlakken);
		var totaal = metMarge(kaal, marge);
		if (totaal <= 0) { return null; }
		if (totaal > PH_MAX_METERS) { return { teGroot: true, kaal: kaal, totaal: totaal }; }

		var perRol = metersPerRol(G.producten, diameter);
		var nodig = rollenNodig(totaal, perRol);
		var pakket = goedkoopstePakket(lijst, nodig);
		if (!pakket) { return null; }

		return {
			kaal: kaal,
			totaal: totaal,
			diameter: diameter,
			metersPerRol: perRol,
			nodigRollen: nodig,
			goedkoopst: pakket,
			pallet: palletStand(G, diameter, pakket)
		};
	}

	/** Waar staat de klant met de palletkorting, inclusief wat er al in de wagen ligt. */
	function palletStand(G, diameter, pakket) {
		var per = G.pallet[diameter];
		if (!per) { return null; }

		var alles = rollenMetVoorstel(G.winkelwagen, diameter, pakket.rollen);
		var deel = palletDeel(G.pallet, alles);
		var pallets = vollePallets(deel);
		var pct = percentageBij(G.treden, pallets);

		var alInWagen = 0;
		Object.keys(G.winkelwagen).forEach(function (d) { alInWagen += G.winkelwagen[d]; });

		return {
			rollenPerDiameter: alles,
			deel: deel,
			pallets: pallets,
			percentage: pct,
			alInWagen: alInWagen,
			geschatteKortingCenten: pct > 0 ? geschatteKortingCenten(pakket.centen, pct) : 0,
			rollenTotEersteTrede: pct > 0 ? 0 : rollenTotEersteTrede(deel, per)
		};
	}

	/* =========================================================================
	 * 9. VAN ADVIES NAAR WINKELWAGEN
	 * ------------------------------------------------------------------------
	 * WooCommerce kreeg dit als tekst "14:2,32:1" in een verborgen veld en
	 * verwerkte het server-side. Shopify wil een lijst met variant-nummers naar
	 * /cart/add.js. Deze functie levert precies dat blok; het versturen zelf
	 * hoort in de section, niet in de rekenkern.
	 *
	 * Het veld heet hier bewust variant_id: op Shopify koop je een VARIANT, niet
	 * een product. In producten.json staat nu nog de WooCommerce-id.
	 * ====================================================================== */
	function cartAddPayload(pakket) {
		return {
			items: pakket.regels.map(function (r) {
				return { id: r.product.variant_id || r.product.id, quantity: r.aantal };
			})
		};
	}
	/* ---------- EINDE rekentools/kern.js ---------- */

	global.BBKern = {
		euroUitCenten: euroUitCenten,
		getal: getal,
		meterTekst: meterTekst,
		procentTekst: procentTekst,
		paneelWoord: paneelWoord,
		diameters: diameters,
		vanDiameter: vanDiameter,
		metersPerRol: metersPerRol,
		passendeDiameter: passendeDiameter,
		rollenNodig: rollenNodig,
		goedkoopstePakket: goedkoopstePakket,
		preciesPakket: preciesPakket,
		samenstelling: samenstelling,
		zelfdePakket: zelfdePakket,
		palletDeel: palletDeel,
		vollePallets: vollePallets,
		percentageBij: percentageBij,
		rollenMetVoorstel: rollenMetVoorstel,
		rollenTotEersteTrede: rollenTotEersteTrede,
		geschatteKortingCenten: geschatteKortingCenten,
		kortingAfrondenOmhoog: kortingAfrondenOmhoog,
		kortingBedrag: kortingBedrag,
		KH_PANEEL_BREEDTE: KH_PANEEL_BREEDTE,
		KH_MAX_METERS: KH_MAX_METERS,
		keuzehulpMetersUitMeters: keuzehulpMetersUitMeters,
		keuzehulpMetersUitPanelen: keuzehulpMetersUitPanelen,
		PH_LANG_STANDAARD: PH_LANG_STANDAARD,
		PH_KORT_STANDAARD: PH_KORT_STANDAARD,
		PH_AANTAL_STANDAARD: PH_AANTAL_STANDAARD,
		PH_MARGE_STANDAARD: PH_MARGE_STANDAARD,
		PH_MAX_METERS: PH_MAX_METERS,
		PH_MAX_GROEPEN: PH_MAX_GROEPEN,
		PH_MAX_PANELEN: PH_MAX_PANELEN,
		vlakLang: vlakLang,
		vlakKort: vlakKort,
		rijBreedte: rijBreedte,
		rijHoogte: rijHoogte,
		vlakMeters: vlakMeters,
		vlakGeldig: vlakGeldig,
		totaalKaal: totaalKaal,
		metMarge: metMarge,
		keuzehulpAdvies: keuzehulpAdvies,
		paneelhulpAdvies: paneelhulpAdvies,
		palletStand: palletStand,
		cartAddPayload: cartAddPayload
	};
}(typeof window !== 'undefined' ? window : globalThis));
